export const UNALLOCATED_NETWORK = 'UNALLOCATED';

export const isUnallocatedNetwork = (network: string | null | undefined): boolean =>
  (network ?? '').toUpperCase() === UNALLOCATED_NETWORK;
